export class SelectDrugChangePrice {
    public constructor(
        oldPrice: number,
        newPrice: number,
        drugId: string
    ) {
       this.drugId=drugId;
       this.newPrice=newPrice;
       this.oldPrice=oldPrice;
    }
    public oldPrice: number;
    public newPrice: number;
    public drugId: string;
    
}
